module.exports = __webpack_public_path__ + "img/504D3C_979C9D_81837D_9C998A-256px.043a8d84.png";